import {
	isAuthenticated,
} from 'services';
import {
	HttpInterceptor,
} from 'utils/http';
import {
	contains,
} from 'utils/text';
import {
	database, SettingKey,
} from '../utils/database';
import {
	SessionToken, Setting,
} from '../models';


/**
 * Checking if the users token still is valid post
 * @param url
 * @param response
 */
export const responseStatusInterceptor: HttpInterceptor<Response> =
	async (url: string, response: Response): Promise<Response> => {
		if (contains(url, ['localhost', 'tradesolution.no']) && response.status === 401) {
			await database.settings.get(SettingKey.SESSION)
				.then((data: Setting<SessionToken> | undefined) => isAuthenticated(data?.value));
			return response;
		}
		return response;
	};